{
  "welcome": "Chào mừng đến với",
  "instructions": "Nhấn vào bên dưới để bắt đầu quy trình check-in.",
  "startCheckIn": "Bắt đầu check-in",
  "missingWarehouseTitle": "Thiếu thông tin kho hàng",
  "missingWarehouseMessage": "Liên kết không hợp lệ, liên kết phải chứa ID kho hàng",
  "recaptchaAttribution": "Trang web này được bảo vệ bởi reCAPTCHA và áp dụng {privacyPolicy} cùng {termsOfService} của Google.",
  "recaptchaPrivacyPolicy": "Chính sách quyền riêng tư",
  "recaptchaTermsOfService": "Điều khoản dịch vụ",
  "lookupTitle": "Nhập Số tham chiếu hoặc Số xác nhận để tìm cuộc hẹn của bạn",
  "referenceNumberLabel": "Số tham chiếu hoặc Số xác nhận",
  "referenceNotFoundError": "Số tham chiếu hoặc số xác nhận không khớp với bất kỳ cuộc hẹn hợp lệ nào.",
  "checkIn": "Check-in",
  "loadTypeLabel": "Loại hàng",
  "directionLabel": "Hướng",
  "operationLabel": "Hoạt động",
  "dockLabel": "Cửa kho",
  "orDivider": "hoặc",
  "noReferenceTitle": "Tôi không có số xác nhận",
  "noReferenceDescription": "Tiếp tục mà không có cuộc hẹn bằng quy trình check-in tiêu chuẩn.",
  "checkInWithoutAppointment": "Check-in không có cuộc hẹn",
  "readyToCheckInTitle": "Sẵn sàng check-in?",
  "readyToCheckInDescription": "Nhấn bên dưới để bắt đầu. Bạn sẽ nhập thông tin ở màn hình tiếp theo.",
  "referenceRequiredHint": "Cần có số tham chiếu để check-in tại địa điểm này.",
  "haveAppointment": "Tôi có cuộc hẹn",
  "direction": {
    "inbound": "Nhập hàng",
    "outbound": "Xuất hàng",
    "inOut": "Nhập & Xuất hàng",
    "load": "Xếp hàng",
    "unload": "Dỡ hàng"
  },
  "operation": {
    "live": "Bốc dỡ trực tiếp (Live)",
    "drop": "Thả rơ-moóc (Drop)",
    "other": "Khác"
  }
}
